module.exports = __webpack_public_path__ + "static/media/model_v041.91169cff.glb";